import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { enum_api_uri } from "../utils/enum";
import { TrackingResponse } from "./usePostTrackingList";

interface TrackingAddPrintRequest {
    pcmobile: string;
    idx: number;
    bl_cnt: number;
    s_cnt: number;
    s_weight?: number;
}

interface TrackingAddPrintResponse {
    statusCode: number;
    message: string;
    data: TrackingAddPrintRequest[];
}

export const usePostTrackingAddNextPrint = (
    successCallback?: (data: TrackingResponse) => void,
): UseMutationResult<TrackingResponse, AxiosError<TrackingAddPrintResponse>, TrackingAddPrintRequest> => {
    const accessToken = useMorningAuthStore(state => state.accessToken);

    return useMutation<TrackingResponse, AxiosError<TrackingAddPrintResponse>, TrackingAddPrintRequest>({
        mutationFn: async requestData => {
            const response = await axios.post(enum_api_uri.order_add_next_print, requestData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data.data;
        },
        onSuccess: data => {
            successCallback?.(data);
        },
    });
};
